import React from 'react';
import {toLastUpdateString} from '../../../logics/utility';
import { 
	func, 
	array ,
	bool,
	string,
	object
} from 'prop-types';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from './style';

const Presenter = ({
	recipe,
	fav,
	likeFrom,
	thumbFrom,
	hasThumbOfMe,
	updatingFav,
	onClickTag,
	onClickPlay,
	onClickBack,
	onClickStar,
	updatingThumb,
	onClickThumbs,
	onClickUser,
	scores,
	className,
	t
}) =>{
	const quizCount = recipe.quizzes ? recipe.quizzes.filter(q=>!q.isSample&&q.checked).length : 0;
	const timeLimit = recipe.timeLimit ? (`${Math.floor(recipe.timeLimit / 60)}[m]${Math.floor(recipe.timeLimit % 60)}[s]`) : ' - ';
	const lastUpdated = toLastUpdateString(recipe.lastUpdate);
	return (
		<style.Wrapper className={className}>
			<style.Header>
				<style.IconButton onClick={onClickBack}><style.ArrowLeftIcon/></style.IconButton>
				<style.HeaderTextWrapper>
					<style.Title>
						{recipe.name}
					</style.Title>
					<style.UserName onClick={onClickUser(recipe.uid)}>
						{recipe.userName}
					</style.UserName>
				</style.HeaderTextWrapper>
				<style.TagsWrapper>
					{recipe.tags && recipe.tags.map(tag=><style.ReadOnlyTag 
						text={tag} 
						key={tag} 
						onClick={onClickTag}
					/>)}
				</style.TagsWrapper>
			</style.Header>
			<style.Body>
				<style.DiscriptionWrapper>
					<style.Discription>
						{recipe.discription || '-'}
					</style.Discription>
					<div>
						<style.QuizInfo>
							<style.OkSignIcon/>{`${quizCount} quizzes | `}
							<style.TimerIcon/>{`${timeLimit}`}
						</style.QuizInfo>
						<style.LastUpdate>
							{t('recipe-detail.LastUpdate')} : {lastUpdated}
						</style.LastUpdate>	
					</div>
				</style.DiscriptionWrapper>
				
				<style.h4>{t('recipe-detail.Sample')}</style.h4>
				<style.QuizContent 
					recipe={recipe}
					isSample
				/>
				<style.h4>{t('recipe-detail.YourScore')}</style.h4>
				<style.ScoreChart 
					scores={scores}
				/>
				
			</style.Body>
			<style.ActionsWrapper>
				<style.PlayButton disabled={quizCount===0} onClick={()=>{onClickPlay(recipe);}}><style.PlayIcon/>Play</style.PlayButton>
				<style.ActionIconsWrapper>
					<style.ActionIconButton onClick={onClickThumbs} disabled={updatingThumb||hasThumbOfMe}>
						<style.ThumbsUpIcon/>
						<style.IconText>{thumbFrom.length}</style.IconText>
					</style.ActionIconButton>
					<style.ActionIconButton onClick={onClickStar} disabled={updatingFav}>
						<style.StarIcon fav={ (fav>0?fav.toString() : null) }/>
						<style.IconText>{likeFrom.length}</style.IconText>
					</style.ActionIconButton>
				</style.ActionIconsWrapper>
			</style.ActionsWrapper>
		</style.Wrapper>);
};
	

Presenter.propTypes = {
	recipe : object.isRequired,
	fav : bool,
	thumbFrom : array.isRequired,
	likeFrom : array.isRequired,
	hasThumbOfMe : bool.isRequired,
	updatingFav : bool.isRequired,
	updatingThumb : bool.isRequired,
	onClickTag : func.isRequired,
	onClickPlay: func.isRequired,
	onClickBack: func.isRequired,
	onClickStar: func.isRequired,
	onClickThumbs: func.isRequired,
	onClickUser: func.isRequired,
	scores : array,
	className:string,
	t: func.isRequired
};

export default withNamespaces()(Presenter);